/*@ngInject*/
export default ['$resource','BASE_URL', function ($resource, BASE_URL){ return $resource(BASE_URL + "/msisdns/:resource/:action", {}, {
    sendConfirmNumber: {method: 'POST', params: {resource: 'verification', action: 'start'}},
    confirmNumber: {method: 'POST', params: {resource: 'import'}}
})}];
